import { Info } from "lucide-react";

export default function Disclaimer({ compact = false }) {
  if (compact) {
    return (
      <div data-testid="disclaimer-compact" className="text-xs text-[#6B6B6B] italic border-l-2 border-[#C25934] pl-3 py-1">
        Stima indicativa a supporto della pianificazione di liquidità. Non sostitutiva degli adempimenti fiscali ufficiali del proprio commercialista.
      </div>
    );
  }
  return (
    <div data-testid="disclaimer-banner" className="flex items-start gap-3 bg-[#EBE5DF] border border-[#EBE5DF] rounded-md px-4 py-3">
      <Info size={18} className="mt-0.5 text-[#1E3F33] shrink-0" />
      <p className="text-sm text-[#2C2C2C] leading-relaxed">
        <span className="font-medium">Attenzione:</span> i valori mostrati sono una <span className="font-medium">stima indicativa</span> a supporto della pianificazione di liquidità. Non sostituiscono in alcun modo gli adempimenti fiscali ufficiali del proprio commercialista.
      </p>
    </div>
  );
}
